import * as THREE from 'three';

export interface CoursePlayer extends OpenGolfSim.Player {}

export class CoursePlayer {
  strokes = 0;
  toPar = 0;
  disabled: boolean;
  player: OpenGolfSim.Player;
  currentClub: OpenGolfSim.Club;
  previousStart?: THREE.Vector3;
  originalStart?: THREE.Vector3;
  originalAim?: THREE.Vector3;
  start: THREE.Vector3;
  aim?: THREE.Vector3;
  pin?: THREE.Vector3;
  scorecard: Map<string, number>;
  /**
   * Which holes this player has actually holed out on.
   *
   * Deliberately NOT derived from `scorecard`: that map is written on every
   * stroke, so presence in it means "has teed off", not "has finished". Reading
   * finish state off it marked a player done from their tee shot onward, which
   * `_nextHole()` and `#findNextPlayerUp()` both depend on being correct.
   */
  finishedHoles: Set<string>;

  constructor(player: OpenGolfSim.Player) {
    this.player = player;
    this.name = player.name;
    this.id = player.id;
    this.clubs = player.clubs;
    this.disabled = false;
    
    this.currentClub = player.clubs[0]; // select first
    this.scorecard = new Map();
    this.finishedHoles = new Set();
    this.start = new THREE.Vector3(0, 0, 0);
  }

  hasFinishedHole(holeNumber: string) {
    return this.finishedHoles.has(`${holeNumber}`);
  }

  finishHole(holeNumber: string) {
    this.finishedHoles.add(`${holeNumber}`);
  }

  resetPositions(holeStart: THREE.Vector3, holePin: THREE.Vector3, holeAim?: THREE.Vector3) {
    // TODO: autoselect club based on aim distance?
    this.currentClub = this.clubs[0];
    this.previousStart = undefined;
    this.originalStart = holeStart.clone();
    this.start = holeStart.clone();
    this.pin = holePin.clone();
    
    this.originalAim = holeAim?.clone();
    this.aim = holeAim?.clone();
  }
}